// extracted by mini-css-extract-plugin
module.exports = {"showBlock":"CurrentShow_showBlock__3QNFh","showInfoBlock":"CurrentShow_showInfoBlock__3L4A4","summary":"CurrentShow_summary__3Hlwv"};